import { supabase } from '@/lib/supabaseClient';

type AuthUserMetadataUpdate = Record<string, string | number | boolean | null>;

interface AuthUserUpdates {
  email?: string;
  password?: string;
  data?: AuthUserMetadataUpdate;
}

export async function signUpWithEmail(email: string, password: string) {
  const { data, error } = await supabase.auth.signUp({ email, password });
  if (error) throw error;
  return data;
}

export async function signInWithEmail(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) {
    const normalizedMessage = typeof error.message === 'string' ? error.message.toLowerCase() : '';
    if (!normalizedMessage.includes('auth session missing')) {
      throw error;
    }
  }
  return true;
}

export async function getCurrentUser() {
  const { data } = await supabase.auth.getUser();
  return data.user;
}

export async function getCurrentSession() {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export async function setSession(accessToken: string, refreshToken: string) {
  const { data, error } = await supabase.auth.setSession({ access_token: accessToken, refresh_token: refreshToken });
  if (error) throw error;
  return data.session;
}

export async function refreshCurrentSession() {
  const { data, error } = await supabase.auth.refreshSession();
  if (error) throw error;
  return data.session;
}

export async function updateAuthUser(updates: AuthUserUpdates) {
  const { data, error } = await supabase.auth.updateUser(updates);
  if (error) throw error;
  return data.user;
}

export async function resetPasswordForEmail(email: string) {
  const { error } = await supabase.auth.resetPasswordForEmail(email, {
    redirectTo: window.location.origin + '/reset-password',
  });
  if (error) throw error;
  return true;
}
